import React from "react";
import { useLanguage } from "@/lib/i18n";

/**
 * Strategic positioning section — Felipe's anchor tagline.
 * Placed between InsightSection and DailyAISection on the landing.
 * Pure copy block with strong visual contrast (white type on dark navy).
 */
export default function PositioningSection() {
  const { lang } = useLanguage();
  return (
    <section
      className="bg-[#0B2545] text-[#F9F8F6] py-24 sm:py-32"
      data-testid="positioning-section"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <p className="text-xs uppercase tracking-[0.22em] text-[#B4C5A4] font-sans-display font-medium mb-6">
          {lang === "es" ? "Posicionamiento" : "Posicionament"}
        </p>
        <h2 className="font-sans-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.15] mb-8">
          {lang === "es" ? (
            <>
              AI METABOLIC acompaña a la persona{" "}
              <span className="italic font-serif-display text-[#B4C5A4]">antes del primer gran paso</span>
              .
            </>
          ) : (
            <>
              AI METABOLIC acompanya la persona{" "}
              <span className="italic font-serif-display text-[#B4C5A4]">abans del primer gran pas</span>
              .
            </>
          )}
        </h2>
        <p className="text-lg sm:text-xl text-[#F9F8F6]/85 leading-relaxed max-w-3xl">
          {lang === "es"
            ? "Te ayuda a entender qué te bloquea, a recuperar confianza y a llegar mejor preparado al profesional adecuado."
            : "T'ajuda a entendre què et bloqueja, a recuperar confiança i a arribar millor preparat al professional adequat."}
        </p>
        <div className="mt-12 grid sm:grid-cols-3 gap-6">
          {[
            { ca: "Entendre què et bloqueja", es: "Entender qué te bloquea" },
            { ca: "Recuperar confiança", es: "Recuperar confianza" },
            { ca: "Arribar preparat al següent pas", es: "Llegar preparado al siguiente paso" },
          ].map((step, i) => (
            <div key={i} className="border-l border-[#B4C5A4]/40 pl-5 py-1">
              <p className="text-xs uppercase tracking-[0.18em] text-[#B4C5A4] font-sans-display font-medium mb-2">
                {String(i + 1).padStart(2, "0")}
              </p>
              <p className="font-sans-display text-base sm:text-lg text-[#F9F8F6] tracking-tight leading-snug">
                {step[lang]}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
